import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import {
  browserCookieIdExperiments,
  userIdExperiments
} from '~/constants/srp/experiments';
import { useSelectedTrade } from '~/context/common/TradeContext';
import { useUserIsImpersonating } from '~/context/common/UserContext';
import {
  useDealershipId,
  useIsDealershipPage
} from '~/context/dealership/StaticContext';
import { useFinanceInfo } from '~/context/srp/FinanceContext';
import useEventExperiments from '~/hooks/common/telemetry/useEventExperiments';
import useSendFeatureBranchToDataDog from '~/hooks/common/telemetry/useSendFeatureBranchToDataDog';
import useSendNativeDeviceTypeToDataDog from '~/hooks/common/telemetry/useSendNativeDeviceTypeToDataDog';

export default function useSetDataDogContext() {
  const financeInfo = useFinanceInfo();
  const tradeInfo = useSelectedTrade();
  const isImpersonating = useUserIsImpersonating();
  const dealershipId = useDealershipId();
  const isDealershipPage = useIsDealershipPage();

  useSendFeatureBranchToDataDog();
  useSendNativeDeviceTypeToDataDog();
  useEventExperiments(browserCookieIdExperiments, userIdExperiments);

  useEffect(() => {
    datadogRum.setGlobalContextProperty('isImpersonating', isImpersonating);
    datadogRum.setGlobalContextProperty(
      'softpullStatus',
      financeInfo?.financingType
    );
    datadogRum.setGlobalContextProperty(
      'tradeStatus',
      tradeInfo?.lifeCycleState
    );
    datadogRum.setGlobalContextProperty('dealershipId', dealershipId);
    datadogRum.setGlobalContextProperty('isDealershipPage', isDealershipPage);
  }, [
    dealershipId,
    financeInfo?.financingType,
    isDealershipPage,
    isImpersonating,
    tradeInfo?.lifeCycleState
  ]);
}
